import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  ModernDialog_getInstance34rv0w4qmp4oc as ModernDialog_getInstance,
  LargeSelectionCards_getInstance3chs6is67e0a5 as LargeSelectionCards_getInstance,
  DisputeButton_getInstance2kmp95ogq1c02 as DisputeButton_getInstance,
} from '../theming/formThemes.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import {
  DisputeType_LineItem_getInstanceq2lrx3mzykb as DisputeType_LineItem_getInstance,
  DisputeType_ProjectWide_getInstance2cdu0u5z6ld8p as DisputeType_ProjectWide_getInstance,
} from '../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.via_1.tia_1(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_elvis_lhs = $this.wia_1.uia_1.f2();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp_0 = $this.wia_1.tia_1(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.xia_1.tia_1(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var DisputeWorkItemConfirmation$render$slambdaClass;
function DisputeWorkItemConfirmation$render$slambda() {
  if (DisputeWorkItemConfirmation$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DisputeWorkItemConfirmation$render$slambdaClass = $;
  }
  return DisputeWorkItemConfirmation$render$slambdaClass;
}
function DisputeWorkItemConfirmation$render$slambda_0() {
  var i = new (DisputeWorkItemConfirmation$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DisputeWorkItemConfirmation$render$slambdaClass_0;
function DisputeWorkItemConfirmation$render$slambda_1() {
  if (DisputeWorkItemConfirmation$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.via_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DisputeWorkItemConfirmation$render$slambdaClass_0 = $;
  }
  return DisputeWorkItemConfirmation$render$slambdaClass_0;
}
function DisputeWorkItemConfirmation$render$slambda_2(this$0) {
  var i = new (DisputeWorkItemConfirmation$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var DisputeWorkItemConfirmation$render$slambdaClass_1;
function DisputeWorkItemConfirmation$render$slambda_3() {
  if (DisputeWorkItemConfirmation$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.wia_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DisputeWorkItemConfirmation$render$slambdaClass_1 = $;
  }
  return DisputeWorkItemConfirmation$render$slambdaClass_1;
}
function DisputeWorkItemConfirmation$render$slambda_4(this$0) {
  var i = new (DisputeWorkItemConfirmation$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DisputeWorkItemConfirmation$render$slambdaClass_2;
function DisputeWorkItemConfirmation$render$slambda_5() {
  if (DisputeWorkItemConfirmation$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.xia_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DisputeWorkItemConfirmation$render$slambdaClass_2 = $;
  }
  return DisputeWorkItemConfirmation$render$slambdaClass_2;
}
function DisputeWorkItemConfirmation$render$slambda_6(this$0) {
  var i = new (DisputeWorkItemConfirmation$render$slambda_5())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DisputeWorkItemConfirmationClass;
function DisputeWorkItemConfirmation() {
  if (DisputeWorkItemConfirmationClass === VOID) {
    class $ {
      constructor(action) {
        this.tia_1 = action;
        this.uia_1 = Signal().hak(null);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(DisputeWorkItemConfirmation$render$slambda_0());
        var tmp = view.kbb(view.kbb(sizeConstraints(view, VOID, get_rem(50)), get_centered(view)), view.jbb(ModernDialog_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title(view_0, 'Select Dispute Type');
        var tmp_0 = view_0.jbb(LargeSelectionCards_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        var tmp_1 = view_1.kbb(get_expanding(view_1), get_viewIsWide(view_1) ? sizeConstraints(view_1, VOID, VOID, VOID, VOID, 1.2) : Companion_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$0 = view_1.jbb(CardSemantic_getInstance());
        var tmp_2 = view_1.kbb(tmp_1, tmp$ret$0);
        // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RadioToggleButton())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.bb9(get_appTheme().jb0_1);
        title(view_3, 'Work Item Dispute');
        body(view_3, 'Dispute only this work item. This will allow work to continue in other work items, but this work item will be frozen until the dispute is resolved.');
        view_2.hbb(p_3, view_3);
        view_2.zah(view_2.bc9_1, equalTo(this.uia_1, DisputeType_LineItem_getInstance()));
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_2, view_2);
        var tmp_3 = view_1.kbb(get_expanding(view_1), get_viewIsWide(view_1) ? sizeConstraints(view_1, VOID, VOID, VOID, VOID, 1.2) : Companion_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$8 = view_1.jbb(CardSemantic_getInstance());
        var tmp_4 = view_1.kbb(tmp_3, tmp$ret$8);
        // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RadioToggleButton())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_appTheme().jb0_1);
        title(view_5, 'Project Dispute');
        body(view_5, 'Dispute the whole project. This will put all other work items on hold, freezing work on the project until the dispute is resolved.');
        view_4.hbb(p_5, view_5);
        view_4.zah(view_4.bc9_1, equalTo(this.uia_1, DisputeType_ProjectWide_getInstance()));
        view_1.hbb(p_4, view_4);
        view_1.lbb(tmp_4, view_4);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        var tmp_5 = get_atEnd(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.gbb(p_6, view_6);
        view_6.zbm(false);
        var tmp_6 = get_textButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        specCenteredText(view_7, 'Go Back');
        onClick(view_7, VOID, VOID, DisputeWorkItemConfirmation$render$slambda_2(this));
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_6, view_7);
        var tmp_7 = view_6.kbb(sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, get_rem(8)), view_6.jbb(DisputeButton_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.gbb(p_8, view_8);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = Button$_get_enabled_$ref_61t7nx(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          var tmp$ret$23 = !($this$reactiveScope.daj(this.uia_1) == null);
          this_0.set(tmp$ret$23);
          return Unit_instance;
        });
        specCenteredText(view_8, 'Begin');
        onClick(view_8, VOID, VOID, DisputeWorkItemConfirmation$render$slambda_4(this));
        view_6.hbb(p_8, view_8);
        view_6.lbb(tmp_7, view_8);
        view_0.hbb(p_6, view_6);
        view_0.lbb(tmp_5, view_6);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        view.vbo(DisputeWorkItemConfirmation$render$slambda_6(this));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'DisputeWorkItemConfirmation', VOID, VOID, [Page()]);
    DisputeWorkItemConfirmationClass = $;
  }
  return DisputeWorkItemConfirmationClass;
}
//region block: exports
export {
  DisputeWorkItemConfirmation as DisputeWorkItemConfirmation3j4bsdnn01wun,
};
//endregion

//# sourceMappingURL=DisputeWorkItemConfirmation.mjs.map
